import { render, staticRenderFns } from "./newReport.vue?vue&type=template&id=f7e80972&scoped=true&"
import script from "./newReport.vue?vue&type=script&lang=js&"
export * from "./newReport.vue?vue&type=script&lang=js&"
import style0 from "./newReport.vue?vue&type=style&index=0&id=f7e80972&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e80972",
  null
  
)

export default component.exports